import { useCallback, useMemo, useState } from "react";
import AgGridClient from "../../components/AgGridClient";
import {
  useCellRenderer,
  tooltipGetters,
} from "../../utils/cellRendererFactory";

export default function TaskList({ tasks, workflowId }) {
  const [gridApi, setGridApi] = useState(null);

  const handleGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const simpleRenderer = useCellRenderer("simple");
  const timeRenderer = useCellRenderer("time");
  const taskLinkRenderer = useCellRenderer("taskLink", true, { workflowId });

  const columnDefs = useMemo(
    () => [
      {
        field: "seq",
        headerName: "Seq",
        filter: "agNumberColumnFilter",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        width: 100,
        minWidth: 80,
        flex: 1,
        filter: false,
      },
      {
        field: "taskId",
        headerName: "Task ID",
        cellRenderer: taskLinkRenderer,
        tooltipValueGetter: tooltipGetters.taskLink,
        filter: "agTextColumnFilter",
        width: 500,
        minWidth: 300,
        flex: 1,
      },
      {
        field: "workflowTask.name",
        headerName: "Task Name",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        filter: "agTextColumnFilter",
        width: 500,
        minWidth: 300,
        flex: 1,
      },
      {
        field: "referenceTaskName",
        headerName: "Ref",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        filter: "agTextColumnFilter",

        width: 500,
        minWidth: 300,
        flex: 1,
      },
      {
        field: "workflowTask.type",
        headerName: "Type",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        filter: "agTextColumnFilter",

        width: 500,
        minWidth: 300,
        flex: 1,
      },
      {
        field: "scheduledTime",
        headerName: "Scheduled Time",
        cellRenderer: timeRenderer,
        tooltipValueGetter: tooltipGetters.time,
        filter: "agDateColumnFilter",

        width: 500,
        minWidth: 300,
        flex: 1,
      },
      {
        field: "startTime",
        headerName: "Start Time",
        cellRenderer: timeRenderer,
        tooltipValueGetter: tooltipGetters.time,
        width: 500,
        minWidth: 300,
        filter: "agDateColumnFilter",

        flex: 1,
      },
      {
        field: "endTime",
        headerName: "End Time",
        cellRenderer: timeRenderer,
        tooltipValueGetter: tooltipGetters.time,
        width: 500,
        minWidth: 300,
        filter: "agDateColumnFilter",

        flex: 1,
      },
      {
        field: "status",
        headerName: "Status",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        width: 500,
        minWidth: 300,
        flex: 1,
        filter: "agTextColumnFilter",
      },
      {
        field: "updateTime",
        headerName: "Update Time",
        cellRenderer: timeRenderer,
        tooltipValueGetter: tooltipGetters.time,
        width: 500,
        minWidth: 300,
        flex: 1,
        filter: "agDateColumnFilter",
      },
      {
        field: "callbackAfterSeconds",
        headerName: "Callback After Seconds",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        width: 500,
        minWidth: 300,
        flex: 1,
        filter: "agNumberColumnFilter",
      },
      {
        field: "pollCount",
        headerName: "Poll Count",
        cellRenderer: simpleRenderer,
        tooltipValueGetter: tooltipGetters.simple,
        width: 500,
        minWidth: 300,
        flex: 1,
        filter: "agNumberColumnFilter",
      },
    ],
    [simpleRenderer, timeRenderer, taskLinkRenderer]
  );

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    }),
    []
  );

  const defaultVisibleColumns = useMemo(
    () => [
      "seq",
      "taskId",
      "workflowTask.name",
      "referenceTaskName",
      "workflowTask.type",
      "startTime",
      "endTime",
      "status",
    ],
    []
  );

  const [visibleColumns, setVisibleColumns] = useState(defaultVisibleColumns);

  const handleColumnSelectionChange = useCallback((selected) => {
    setVisibleColumns(selected);
  }, []);

  const filteredColumnDefs = useMemo(
    () => columnDefs.filter((col) => visibleColumns.includes(col.field)),
    [columnDefs, visibleColumns]
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        paddingBottom: "90px",
      }}
    >
      <AgGridClient
        rowData={tasks}
        columnDefs={filteredColumnDefs}
        defaultColDef={defaultColDef}
        paginationPageSize={5}
        onGridReady={handleGridReady}
        gridApi={gridApi}
        selectedColumns={visibleColumns}
        defaultVisibleColumns={defaultVisibleColumns}
        onColumnSelectionChange={handleColumnSelectionChange}
        allColumnDefs={columnDefs}
      />
    </div>
  );
}
